import React, { useEffect, useState } from "react";
import { Checkbox, notification, Table } from "antd";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import { GetRegionsList } from "../../API/endpoints/Regions";
import { BrandsType, MarketPreference } from "./dtos/brands.dtos";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { error } from "console";


type TableUiExpansionEdgeProps = {
    nextStep: () => void;
    previousStep: () => void;
    data: BrandsType;
    setData: React.Dispatch<React.SetStateAction<BrandsType>>;
    isMobile?: boolean;
};


const TableUiExpansionEdge: React.FC<TableUiExpansionEdgeProps> = ({ nextStep, previousStep, setData, data, isMobile }) => {
    // const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
    const [selectedMarkets, setSelectedMarkets] = useState<{ [key: string]: boolean }>({});
    const [columnCheckedItems, setColumnCheckedItems] = useState<{ [key: string]: boolean }>({});
    const [api, contextHolder] = notification.useNotification();
    const openNotification = (placement: 'top') => {
        api.info({
            message: `Notification ${placement}`,
            description:
                'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
            placement,
        });
    };
    const handleSelectAllMarkets = () => {
        const allSelected = markets.every((market) => selectedMarkets[market.id]);

        const newSelectedMarkets: { [key: string]: boolean } = {};
        markets.forEach((market) => {
            newSelectedMarkets[market.id] = !allSelected;
        });

        setSelectedMarkets(newSelectedMarkets);
    };
    const isChecked = (regionId: string, field: keyof MarketPreference): boolean => {
        const match = data.market_preference?.find((m) => m.region === parseInt(regionId));
        return !!match?.[field]; // this will convert 0, 1, undefined to proper boolean
    };


    const [allMarkets, setAllMarkets] = useState<any[]>([]);

    useEffect(() => {
        (async () => {
            try {
                const response = await GetRegionsList();
                setAllMarkets(response.data.map((item: any) => item));
            } catch (error) { }
        })();
    }, []);

    const keyChannelFields: (keyof MarketPreference)[] = [
        'offline_retail',
        'online',
        'food_service',
    ];

    const keyCapabilityFields: (keyof MarketPreference)[] = [
        'regulatory_compliance',
        'importation_clearance',
        'ambient_warehousing',
        'cold_and_frozen_warehousing',
        'retail_distribution',
        'sales',
        'marketing',
    ];


    const handleNextStep = () => {
        const keyChannelFields: (keyof MarketPreference)[] = [
            "offline_retail",
            "online",
            "food_service",
        ];

        const keyCapabilityFields: (keyof MarketPreference)[] = [
            "regulatory_compliance",
            "importation_clearance",
            "ambient_warehousing",
            "cold_and_frozen_warehousing",
            "retail_distribution",
            "sales",
            "marketing",
        ];


        const selectedMarketIds = Object.keys(selectedMarkets).filter(
            (id) => selectedMarkets[id]
        );

        const invalidMarkets: string[] = [];
        selectedMarketIds.forEach((id) => {
            const pref = data.market_preference?.find(
                (p) => p.region.toString() === id
            );

            const hasChannel = keyChannelFields.some((field) => pref?.[field]);
            const hasCapability = keyCapabilityFields.some((field) => pref?.[field]);

            if (!hasChannel || !hasCapability) {
                const marketName = markets.find((m) => m.id.toString() === id)?.name || `Region ${id}`;
                invalidMarkets.push(marketName);
            }
        });
        // ❗ Validation: At least one market must be selected
        if (selectedMarketIds.length === 0) {
            toast.error("Please select at least one market to proceed.", {
                position: "top-center",
                closeButton: true,
                hideProgressBar: true,
                className:
                    "w-[80%] shadow-md bg-white p-4 text-black mt-[10px] rounded-lg leading-[150%]",
            });
            return;
        }
        if (invalidMarkets.length > 0) {
            toast.error(
                `You’ve selected the following market(s) but haven’t filled in the channel or capability information: ${invalidMarkets.join(", ")}.
Make sure to select at least one option under Key Channel Coverage and Key Capabilities for each before continuing.`,
                {
                    position: "top-center",
                    closeButton: true,
                    hideProgressBar: true,
                    //   autoClose: 3000,
                    className: "w-[80%] shadow-md bg-white p-4 text-black mt-[10px] rounded-lg leading-[150%]",
                }
            );
            return;
        }

        // ✅ All validations passed
        nextStep();
    };




    const handleMarketCheckboxChange = (marketId: string) => {
        setSelectedMarkets((prev) => {
            const isCurrentlySelected = prev[marketId];
            const newSelected = {
                ...prev,
                [marketId]: !isCurrentlySelected,
            };

            // If deselected, remove from market_preference
            if (isCurrentlySelected) {
                setData((prevData) => {
                    const updatedPrefs = (prevData.market_preference || []).filter(
                        (p) => p.region !== Number(marketId)
                    );

                    return {
                        ...prevData,
                        market_preference: updatedPrefs,
                    };
                });
            }

            return newSelected;
        });
    };


    // Update the data
    const updateMarketPreference = (
        regionId: string,
        field: keyof MarketPreference,
        value: boolean
    ) => {
        setData((prevData) => {
            const updatedPreferences = [...(prevData.market_preference ?? [])];

            const index = updatedPreferences.findIndex((p) => p.region === Number(regionId));


            if (index !== -1) {
                updatedPreferences[index] = {
                    ...updatedPreferences[index],
                    [field]: value,
                };
            } else {
                // Check if region already exists (safety check)
                const alreadyExists = updatedPreferences.some(p => p.region === Number(regionId));
                if (!alreadyExists) {
                    updatedPreferences.push({
                        region: Number(regionId),
                        regulatory_compliance: false,
                        importation_clearance: false,
                        marketing: false,
                        retail_distribution: false,
                        offline_retail: false,
                        online: false,
                        food_service: false,
                        ambient_warehousing: false,
                        cold_and_frozen_warehousing: false,
                        sales: false,
                        [field]: value,
                    });
                }
            }

            console.log("updatedPreferences", updatedPreferences);
            return {
                ...prevData,
                market_preference: updatedPreferences,
            };
        });
    };
    useEffect(() => {
        if (Array.isArray(data.market_preference)) {
            const initialSelected: { [key: string]: boolean } = {};
            data.market_preference.forEach((pref) => {
                if (pref?.region !== undefined && pref?.region !== null) {
                    initialSelected[pref.region.toString()] = true;
                }
            });
            setSelectedMarkets(initialSelected);
        }
    }, [data.market_preference]);




    // Handle "select all" for a specific column
    const handleColumnCheckboxChange = (column: string) => {
        const isChecked = !columnCheckedItems[column];
    
        setColumnCheckedItems((prev) => ({
            ...prev,
            [column]: isChecked,
        }));
    
        const fieldMap: Record<string, keyof MarketPreference> = {
            "Regulatory Compliance": "regulatory_compliance",
            "Importation & Clearance": "importation_clearance",
            "Marketing": "marketing",
            "Retail Distribution": "retail_distribution",
            "Offline Retail": "offline_retail",
            "Online": "online",
            "Food Service/Out of Home": "food_service",
            "Ambient Warehousing": "ambient_warehousing",
            "Cold & Frozen Warehousing": "cold_and_frozen_warehousing",
            "Sales": "sales",
        };
    
        const dtoField = fieldMap[column];
        if (!dtoField) return;
    
        const allFields = keyChannelFields.concat(keyCapabilityFields);
    
        setData((prevData) => {
            let updatedPrefs = [...(prevData.market_preference || [])];
    
            // Update the fields
            markets.forEach((market) => {
                const marketId = market.id;
                const index = updatedPrefs.findIndex((p) => p.region === marketId);
    
                if (index !== -1) {
                    updatedPrefs[index] = {
                        ...updatedPrefs[index],
                        [dtoField]: isChecked,
                    };
                } else {
                    updatedPrefs.push({
                        region: marketId,
                        regulatory_compliance: false,
                        importation_clearance: false,
                        marketing: false,
                        retail_distribution: false,
                        offline_retail: false,
                        online: false,
                        food_service: false,
                        ambient_warehousing: false,
                        cold_and_frozen_warehousing: false,
                        sales: false,
                        [dtoField]: isChecked,
                    });
                }
            });
    
            // Now clean up markets with no selection
            updatedPrefs = updatedPrefs.filter((pref) => {
                return allFields.some((field) => pref[field]);
            });
    
            // Build updated selectedMarkets map
            const updatedSelected: { [key: string]: boolean } = {};
            updatedPrefs.forEach((pref) => {
                updatedSelected[pref.region.toString()] = true;
            });
    
            // Update selectedMarkets
            setSelectedMarkets(updatedSelected);
    
            return {
                ...prevData,
                market_preference: updatedPrefs,
            };
        });
    };
    
    
    
    
    




    // const markets = [
    //     'Malaysia', 'Indonesia', 'Thailand', 'Philippines', 'Vietnam',
    //     'S. Korea', 'Japan', 'China', 'Hong Kong', 'Taiwan', 'India'
    //   ];
    const markets = allMarkets.map((item) => {
        return {
            id: item.id,
            name: item.name,
        };
    });

    const columns = [
        'Offline Retail', 'Online', 'Food Service/Out of Home',
        'Regulatory Compliance', 'Importation & Clearance',
        'Warehousing', 'Retail Distribution', 'Sales', 'Marketing'
    ];
    const toggleCheckbox = (regionId: string, field: keyof MarketPreference) => {
        const match = data.market_preference?.find((m) => m.region === parseInt(regionId));
        const currentValue = !!match?.[field];

        updateMarketPreference(regionId, field, !currentValue);
    };

    const columnWithCheckbox = (column: string, isMarketsHeader = false) => {
        // const allMarketsSelected = markets.every((market) => selectedMarkets[market] === true);
        // const someMarketsSelected = markets.some((market) => selectedMarkets[market]);
        const allMarketsSelected = markets.every((market) => selectedMarkets[market.id] === true);
        const someMarketsSelected = markets.some((market) => selectedMarkets[market.id]);

        return (
            <div className="flex items-center gap-2">
                <Checkbox
                    checked={isMarketsHeader ? allMarketsSelected : columnCheckedItems[column]}
                    indeterminate={isMarketsHeader ? someMarketsSelected && !allMarketsSelected : false}
                    onChange={() => (isMarketsHeader ? handleSelectAllMarkets() : handleColumnCheckboxChange(column))}
                />
                {column}
            </div>
        );
    };


    // Ant Design Table Columns
    const tableColumns = [
        {
            title: columnWithCheckbox('Markets', true), // Properly updates on state changes
            dataIndex: 'market',
            width: 150,
            render: (_: any, record: { id: string; name: string }) => (
                <Checkbox
                    // checked={!!selectedMarkets[record.id]}
                    checked={
                        selectedMarkets[record.id] !== undefined
                            ? selectedMarkets[record.id]
                            : data.market_preference?.some((pref) => pref.region && pref.region.toString() === record.id)
                    }
                    onChange={() => handleMarketCheckboxChange(record.id)}
                >
                    {record.name}
                </Checkbox>
            )

        }

        ,
        {
            title: 'Key Channel Coverage',
            children: [
                {
                    title: columnWithCheckbox('Offline Retail'),
                    dataIndex: 'Offline Retail',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            // checked={!!checkedItems[`${record.id}-Offline Retail`]}
                            checked={isChecked(record.id, 'offline_retail')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'offline_retail')
                                // updateMarketPreference(record.id, 'offline_retail', e.target.checked);
                            }}

                        />
                    )
                },
                {
                    title: columnWithCheckbox('Online'),
                    dataIndex: 'Online',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'online')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'online')
                                // updateMarketPreference(record.id, 'online', e.target.checked);
                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Food Service/Out of Home'),
                    dataIndex: 'Food Service/Out of Home',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'food_service')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'food_service')
                                // updateMarketPreference(record.id, 'food_service', e.target.checked);

                            }}
                        />
                    )
                }
            ]
        },
        {
            title: 'Key Capabilities',
            children: [
                {
                    title: columnWithCheckbox('Regulatory Compliance'),
                    dataIndex: 'Regulatory Compliance',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'regulatory_compliance')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'regulatory_compliance')
                                // updateMarketPreference(record.id, 'regulatory_compliance', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Importation & Clearance'),
                    dataIndex: 'Importation & Clearance',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'importation_clearance')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'importation_clearance')
                                // updateMarketPreference(record.id, 'importation_clearance', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Ambient Warehousing'),
                    dataIndex: 'Ambient Warehousing',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'ambient_warehousing')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'ambient_warehousing')
                                // updateMarketPreference(record.id, 'ambient_warehousing', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Cold & Frozen Warehousing'),
                    dataIndex: 'Cold & Frozen Warehousing',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'cold_and_frozen_warehousing')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'cold_and_frozen_warehousing')
                                // updateMarketPreference(record.id, 'cold_and_frozen_warehousing', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Retail Distribution'),
                    dataIndex: 'Retail Distribution',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'retail_distribution')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'retail_distribution')
                                // updateMarketPreference(record.id, 'retail_distribution', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Sales'),
                    dataIndex: 'Sales',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'sales')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'sales')
                                // updateMarketPreference(record.id, 'sales', e.target.checked);

                            }}
                        />
                    )
                },
                {
                    title: columnWithCheckbox('Marketing'),
                    dataIndex: 'Marketing',
                    render: (_: any, record: { id: string; name: string }) => (
                        <Checkbox
                            checked={isChecked(record.id, 'marketing')}
                            onChange={(e) => {
                                toggleCheckbox(record.id, 'marketing')
                                // updateMarketPreference(record.id, 'marketing', e.target.checked);

                            }}
                        />
                    )
                }
            ]
        }
    ];


    // Table Data (each row is a market)
    //   const dataSource = markets.map((market) => {
    //     const row: { key: string; market: string; [key: string]: any } = { key: market, market };
    //     columns.forEach((col) => {
    //       row[col] = null; // placeholder for checkbox (rendered by render)
    //     });
    //     return row;
    //   });
    const dataSource = markets.map((market) => {
        const row: { id: string; name: string; key: string;[key: string]: any } = {
            id: market.id,
            name: market.name,
            key: market.id,
        };

        columns.forEach((col) => {
            row[col] = null;
        });

        return row;
    });






    return (
        <div className="w-full ">
            <div className="w-full max-w-[686px]">
                <div className="common-title pb-[12px]">Your Expansion Edge</div>
                <div className="common-sub-text pb-[60px]">Share us your focus markets, strengths, and channels to unlock global growth opportunities.</div>
            </div>
            {/*Table */}
            <div className="custom-table">
                <Table showHeader={true}
                    rowClassName={"bg-white"}

                    dataSource={dataSource}
                    columns={tableColumns}
                    pagination={false}

                    bordered
                    className="w-full table-auto "
                />
            </div>

            {/* Next Button */}
            <div className="mt-[60px] inline-flex gap-x-[8px]">
                <NavigationButton onClick={previousStep} label="Previous" type="text" />
                <NavigationButton onClick={handleNextStep} label="Next" type="primary" />


            </div>
            <ToastContainer />

        </div>
    );
};

export default TableUiExpansionEdge;